import React from 'react';
import {
  configureFonts,
  Portal,
  Provider as Paper,
  Snackbar,
} from 'react-native-paper';
import { SafeAreaProvider as SafeArea } from 'react-native-safe-area-context';
import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import { get } from 'lodash';
import { ThemeProvider as Styled } from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import useLanguage from '@src/hooks/useLanguage';
import useSnackBar from '@src/hooks/useSnackBar';

import fonts from './fonts';
import Light from './light';

const settings = {
  icon: FontIcon,
};

const Component: React.FC = ({ children }) => {
  const language = useLanguage();
  const { snackBar, hide } = useSnackBar();
  const themeWithLocaleFont = React.useMemo(
    () => ({
      ...Light,
      fonts: configureFonts(get(fonts, language)) as typeof fonts.fa.default,
    }),
    [language]
  );

  return (
    <Styled theme={themeWithLocaleFont}>
      <SafeArea>
        <ActionSheetProvider>
          <Paper settings={settings} theme={themeWithLocaleFont}>
            <Portal>
              {children}
              <Snackbar
                visible={snackBar.visible}
                onDismiss={hide}
                action={snackBar.message?.action}
              >
                {snackBar.message?.content}
              </Snackbar>
            </Portal>
          </Paper>
        </ActionSheetProvider>
      </SafeArea>
    </Styled>
  );
};

Component.displayName = 'Theme';

export default Component;
